// src/pages/teams/[teamId]/PaymentCancelledPage.jsx
import { useEffect, useMemo } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

export default function PaymentCancelledPage() {
  const { teamId: teamIdFromParams } = useParams();
  const { search } = useLocation();
  const navigate = useNavigate();

  // Fallback: also accept ?team=ID for legacy URLs
  const teamId = useMemo(() => {
    return teamIdFromParams || new URLSearchParams(search).get('team') || '';
  }, [teamIdFromParams, search]);

  // Optional: safety redirect after 15s
  useEffect(() => {
    const t = setTimeout(() => {
      if (teamId) navigate(`/teams/${teamId}`);
    }, 15000);
    return () => clearTimeout(t);
  }, [teamId, navigate]);

  return (
    <div className="form-page-container py-12 px-6 text-center max-w-xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Payment cancelled</h2>
      <p className="text-gray-700">
        No money has been taken. You can try again any time.
      </p>

      <div className="mt-6 flex items-center justify-center gap-3">
        <button
          type="button"
          className="button button-secondary"
          onClick={() => teamId && navigate(`/teams/${teamId}`)}
        >
          Return to team
        </button>

        {/* If you want the team page to prompt a retry, listen for this state there */}
        <button
          type="button"
          className="button button-primary"
          onClick={() =>
            teamId && navigate(`/teams/${teamId}`, { state: { retryPayment: true } })
          }
        >
          Try again
        </button>
      </div>

      <p className="text-sm text-gray-500 mt-6">
        If you cancelled by mistake or had an issue, please try again or contact support.
      </p>
    </div>
  );
}
